import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { PlusButton } from '../../../../../components/buttons/PlusButton';
import { SaveButton } from '../../../../../components/buttons/SaveButton';
import { CancelButton } from '../../../../../components/buttons/CancelButton';
import { PartnerContractsTable } from './PartnerContractsTable';
import { DateTimePicker } from '../../../../../components/dateTimePicker/DateTimePicker';
import { DEFAULT_DATE } from '../../../../../components/common/Constants';
import { toDateString } from '../../../../../utils/TimeUtils';
import './PartnerContractsForm.css';

export const PartnerContractsForm = ({ onSubmit, onCancel, partnerTitle, contracts }) => {

    const { t } = useTranslation('partner');
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [items, setItems] = useState([]);
    const [currentContract, setCurrentContract] = useState({
        code: null,
        validTill: null,
        comment: null,
    });

    const handleShow = () => {
        setItems(contracts.sort((a, b) => a.validTill > b.validTill ? 1 : -1));
        setShow(true);

    };

    const onClose = () => {
        onCancel();
        handleClose();
    };

    const onContractNumberInput = (value) => {
        setCurrentContract((prevContract) => {
                return { ...prevContract, code: value };
            },
        );
    };

    const onValidTillInput = (value) => {
        setCurrentContract((prevContract) => {
                return { ...prevContract, validTill: toDateString(value, DEFAULT_DATE) };
            },
        );
    };

    const onCommentInput = (value) => {
        setCurrentContract((prevContract) => {
                return { ...prevContract, comment: value };
            },
        );
    };

    const addContract = () => {
        if (currentContract.code != null || currentContract.validTill != null) {
            setItems(prev => {
                let items = [...prev, currentContract];
                return items.sort((a, b) => a.validTill > b.validTill ? 1 : -1);
            });
            reset();
        }
    };

    const reset = () => {
        setCurrentContract({
            code: null,
            validTill: null,
            comment: null,
        });
        let contractNameElement = document.getElementById('partner-contract-name-input');
        if (contractNameElement) {
            contractNameElement.value = null;
        }
        let validTillElement = document.getElementById('partner-contract-valid-till');
        if (validTillElement) {
            validTillElement.value = null;
        }
        let commentElement = document.getElementById('partner-contract-comment-input');
        if (commentElement) {
            commentElement.value = null;
        }
    };

    const submitContracts = () => {
        onSubmit(items);
        onClose();
    };

    const removeContract = (index) => {
        setItems((prevContracts) =>
            prevContracts.filter((contract, idx) => idx !== index),
        );
    };

    return (
        <>
            <div id={'partner-contracts-show-div'} onClick={handleShow} hidden={true}></div>
            <Modal show={show} onHide={onClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{partnerTitle} {t('contracts.title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={'partner-contracts-form-container'}>
                        <div className={'mb-3'} style={{ width: '60%' }}>
                            <span>{t('contracts.number')}</span>
                            <input type={'text'}
                                   className={'form-control'}
                                   id={'partner-contract-name-input'}
                                   onChange={(e) => onContractNumberInput(e.target.value)} />
                        </div>
                        <div className={'mb-3'} style={{ width: '30%' }}>
                            <span>{t('contracts.validTill')}</span>
                            <DateTimePicker elementId={'partner-contract-valid-till'}
                                            value={null}
                                            onChange={onValidTillInput}
                                            dateFormat={DEFAULT_DATE}
                                            showTime={false}>
                            </DateTimePicker>
                        </div>
                        <PlusButton
                            disabled={currentContract.code == null || currentContract.validTill == null}
                            onClick={addContract}></PlusButton>
                    </div>
                    <div className={'mb-3'}>
                        <span>{t('contracts.comment')}</span>
                        <textarea className={'form-control'}
                                  id={'partner-contract-comment-input'}
                                  onChange={(e) => onCommentInput(e.target.value)} />
                    </div>
                    <PartnerContractsTable contracts={items}
                                           onRemove={removeContract}></PartnerContractsTable>
                    <div className={'center'}>
                        <SaveButton onClick={submitContracts}>
                        </SaveButton>
                        <CancelButton onClick={onClose}></CancelButton>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};